import { render, staticRenderFns } from "./MessagerNotification.vue?vue&type=template&id=40fe6f46&"
import script from "./MessagerNotification.vue?vue&type=script&lang=js&"
export * from "./MessagerNotification.vue?vue&type=script&lang=js&"
import style0 from "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css?vue&type=style&index=0&lang=css&"
import style1 from "./MessagerNotification.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports